const BASE_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:3001';

const getAuthHeader = (): Record<string, string> => {
    const raw = localStorage.getItem('backend_access_token') || '';
    const token = raw.replace(/^"+|"+$/g, '').trim();
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const api = {
    get: async (url: string) => {
        const response = await fetch(`${BASE_URL}${url}`, {
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader()
            }
        });
        if (!response.ok) {
            const text = await response.text();
            try {
                const json = JSON.parse(text);
                throw new Error(json.message || json.error || text);
            } catch {
                throw new Error(text);
            }
        }
        return { data: await response.json() };
    },
    post: async (url: string, body: any) => {
        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader()
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            const text = await response.text();
            try {
                const json = JSON.parse(text);
                throw new Error(json.message || json.error || text);
            } catch {
                throw new Error(text);
            }
        }
        return { data: await response.json() };
    },
    put: async (url: string, body: any) => {
        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader()
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            const text = await response.text();
            try {
                const json = JSON.parse(text);
                throw new Error(json.message || json.error || text);
            } catch {
                throw new Error(text);
            }
        }
        return { data: await response.json() };
    },
    patch: async (url: string, body: any) => {
        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader()
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            const text = await response.text();
            try {
                const json = JSON.parse(text);
                throw new Error(json.message || json.error || text);
            } catch {
                throw new Error(text);
            }
        }
        return { data: await response.json() };
    },
    delete: async (url: string) => {
        const response = await fetch(`${BASE_URL}${url}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader()
            }
        });
        if (!response.ok) {
            const text = await response.text();
            try {
                const json = JSON.parse(text);
                throw new Error(json.message || json.error || text);
            } catch {
                throw new Error(text);
            }
        }
        return { data: await response.json() };
    }
}
